import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { MessageBusService } from 'projects/shared-components/message-bus.service';

@Component({
   selector: 'ets-ledger-note',
   template: `
    <i class="note" *ngIf="params.data.note" (click)="onIconClicked($event)"></i>
    <i *ngIf="!params.data.note"></i>
  `,
   styles: [
      `
      .note {
        width: 20px;
        height: 20px;
        margin-top: 3px;
        text-align: center;
        cursor: pointer;
        background-repeat: no-repeat;
        content: url('data:image/png;base64,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');
      }
    `
   ]
})
export class LedgerNoteCellRendererComponent implements ICellRendererAngularComp {

   constructor(
      private _messageBus: MessageBusService
   ) {}

   params: ICellRendererParams;

   agInit(params: ICellRendererParams): void {
      this.params = params;
   }

   refresh(): boolean {
      return false;
   }

   onIconClicked() {
      this._messageBus.publish({
         topic: 'LedgerNoteClickedUIMessage',
         payload: this.params.data
      });
   }
}


@Component({
   selector: 'ets-ledger-note2',
   template: `
      <span *ngIf="!params.data.note">{{this.params.value}}</span>
      <span *ngIf="params.data.note" [ngClass]="{'comment': !!this.params.data.note}" (click)="onIconClicked()">
         {{this.params.value}}
      </span>
  `,
   styles: [
      `
      .comment {
         cursor: pointer;
      }

      .comment:after {
         content: "";
         position: absolute;
         left: calc(100% - 0.5em);
         top: 0;
         border-left: 0.5em solid transparent;
         border-top: 0.5em solid red;
      }
    `
   ]
})
export class LedgerNote2CellRendererComponent implements ICellRendererAngularComp {

   constructor(
      private _messageBus: MessageBusService
   ) {}

   params: ICellRendererParams;

   agInit(params: ICellRendererParams): void {
      this.params = params;
   }

   refresh(): boolean {
      return false;
   }

   onIconClicked() {
      const layoutTabId = this.params.api['ets-layoutTabId'];
      this._messageBus.publish({
         topic: 'LedgerNoteClickedUIMessage',
         payload: {
            layoutTabId,
            record: this.params.data
         }
      });
   }
}


